<template>
    <router-link to="/">
        <button type="button" id="btnHome" class="btn btn-dark">Home</button>
    </router-link>

    <div id="container" class="center full">
        <ListeReponses />
    </div>
</template>

<script>
import ListeReponses from '../components/ListeReponses.vue';

export default {
    name: 'LearnPage',
    components: {
        ListeReponses
    },
    data() {
        return {

        }
    },
    mounted() {
    }
}
</script>

<style scoped>
.center {
    display: flex;
    justify-content: center;
    align-items: center;
}

#container {
    background-color: rgb(57, 161, 128);
}

#btnHome {
    position: fixed;
    top: 30px;
    left: 30px;
    z-index: 10;
}

#btnRes {
    position: fixed;
    top: 30px;
    right: 30px;
    z-index: 10;
}
</style>
